<template lang="html">
  <div class="cw-accordion accordion" :class="{ closed: !expanded }">
    <div class="accordion-header" @click="toggle">
      <span v-if="showOpenIndicator" class="icon open-indicator">
        <i class="las la-2x la-angle-up" aria-hidden="true"></i>
      </span>
      <slot name="header" :open="expanded"> </slot>
    </div>
    <div class="accordion-content" :style="contentStyles">
      <slot name="content" :open="expanded"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-accordion',
  props: {
    open: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    height: {
      type: String,
      required: false,
      default: '200px',
    },
    showOpenIndicator: {
      type: Boolean,
      required: false,
      default: true,
    },
    overflowType: {
      type: String,
      required: false,
      default: 'visible',
    },
  },
  // variables
  data() {
    return {
      open_: false,
    };
  },
  computed: {
    contentStyles() {
      let openStyle = `
      height: ${this.height};
      transition: all 350ms cubic-bezier(0.080, 1.090, 0.320, 1.275);
      overflow: ${this.overflowType};
      `;
      let closedStyle = `
      height: 0;
      transition: all 500ms cubic-bezier(0.800, -0.280, 0.535, 1.0);
      overflow: hidden;
      `;
      return this.open ? openStyle : closedStyle;
    },
    expanded() {
      if (this.open != 'undefined') return this.open;
      return this.open_;
    },
  },
  methods: {
    toggle() {
      let newExpanded = !this.expanded;
      this._closed = newExpanded;
      this.$emit('update:open', newExpanded);
    },
  },
};
</script>

<style lang="stylus" scoped>

.accordion {

  .accordion-header {
    user-select:none;
    cursor:pointer;
    position: relative;
  }

  .open-indicator {
    position: absolute;
    top: 0;
    right: 0;
    transition: transform 0.3s;
  }

  .accordion-content {
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: stretch;

    transition: all 350ms cubic-bezier(0.080, 1.090, 0.320, 1.275);
  }

  &.closed{

    .open-indicator {
      transform: rotate(-180deg);
    }

    .accordion-content {
      height: 0;
      overflow:hidden;
      transition: all 500ms cubic-bezier(0.800, -0.280, 0.535, 1.0);
    }
  }

}
</style>
